module.exports = __webpack_public_path__ + "static/map-61d9d377497398e40a5a3de31ac3257c.png";